/**
 * Stripe Connect embedded components (`loadConnectAndInitialize`) appearance variables.
 * Light: minimal override (matches existing CourtSync primary).
 * Dark: Stripe’s recommended preset for readable text on dark surfaces — see:
 * https://docs.stripe.com/connect/embedded-appearance-support-dark-mode
 */

const COLOR_PRIMARY_LIGHT = '#2563eb';

/** Brighter primary on dark backgrounds (readable links / primary actions). */
const COLOR_PRIMARY_DARK = '#60a5fa';

/** Stripe demo dark preset + tuned primary to match CourtSync blue family. */
export const STRIPE_CONNECT_DARK_MODE_VARIABLES: Record<string, string> = {
  colorPrimary: COLOR_PRIMARY_DARK,
  colorText: '#C9CED8',
  colorBackground: '#14171D',
  buttonSecondaryColorBackground: '#2B3039',
  buttonSecondaryColorText: '#C9CED8',
  colorSecondaryText: '#8C99AD',
  actionSecondaryColorText: '#C9CED8',
  actionSecondaryTextDecorationColor: '#C9CED8',
  colorBorder: '#2B3039',
  colorDanger: '#F23154',
  badgeNeutralColorBackground: '#1B1E25',
  badgeNeutralColorBorder: '#2B3039',
  badgeNeutralColorText: '#8C99AD',
  badgeSuccessColorBackground: '#152207',
  badgeSuccessColorBorder: '#20360C',
  badgeSuccessColorText: '#3EAE20',
  badgeWarningColorBackground: '#400A00',
  badgeWarningColorBorder: '#5F1400',
  badgeWarningColorText: '#F27400',
  badgeDangerColorBackground: '#420320',
  badgeDangerColorBorder: '#61092D',
  badgeDangerColorText: '#F46B7D',
  offsetBackgroundColor: '#1B1E25',
  formBackgroundColor: '#14171D',
  overlayBackdropColor: 'rgba(0,0,0,0.5)',
};

export const STRIPE_CONNECT_LIGHT_MODE_VARIABLES: Record<string, string> = {
  colorPrimary: COLOR_PRIMARY_LIGHT,
};

export function getStripeConnectAppearanceVariables(isDark: boolean): Record<string, string> {
  return isDark ? { ...STRIPE_CONNECT_DARK_MODE_VARIABLES } : { ...STRIPE_CONNECT_LIGHT_MODE_VARIABLES };
}

/** Call when the app theme toggles so embedded Connect UI stays readable (see Stripe dark mode docs). */
export function applyStripeConnectAppearance(
  instance: unknown,
  isDark: boolean
): void {
  if (!instance || typeof instance !== 'object') return;
  const inst = instance as {
    update?: (opts: { appearance: { variables: Record<string, string> } }) => void;
  };
  inst.update?.({
    appearance: { variables: getStripeConnectAppearanceVariables(isDark) },
  });
}
